import React from 'react';
import { NoResult } from '../styles/TableStyles';

const NoResultFound = ({ setViewChest, setViewSecret, context }) => {
  let searchType = setViewChest ? 'Chests' : setViewSecret ? 'Secrets' : context ? context : 'Items';

  return <NoResult role={'no-result-found'}>No {searchType} Found</NoResult>;
};
export default NoResultFound;
